import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  Unit_instance104q5opgivhr8 as Unit_instance,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toString1pkumu07cwy4m as toString,
  sorted354mfsiv4s7x5 as sorted,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  isInterface3d6p8outrmvmk as isInterface,
} from './kotlin-kotlin-stdlib.mjs';
import { Companion_getInstance2175iaprojxbf as Companion_getInstance } from './korlibs-korlibs-math-vector.mjs';
import { Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_0 } from './korlibs-korlibs-platform.mjs';
import {
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_1,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
} from './korlibs-korlibs-logger.mjs';
import {
  Job13y4jkazwjho0 as Job,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  d5m(formats) {
    return (new AudioFormats()).h5m(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.f(tmp$ret$3);
    }
    tmp.j5m_1 = toSet(destination);
  }
  i5m() {
    return this.j5m_1;
  }
  n3() {
    return 'AudioFormat';
  }
  toString() {
    return this.n3() + '(' + toString(sorted(this.i5m())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f5m_1 = ArrayList.p1();
    this.g5m_1 = null;
  }
  i5m() {
    if (this.g5m_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.f5m_1;
      var destination = ArrayList.p1();
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.i5m();
        addAll(destination, list);
      }
      tmp.g5m_1 = toSet(destination);
    }
    return ensureNotNull(this.g5m_1);
  }
  h5m(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.f5m_1;
    addAll_0(this_1, formats);
    return this_0;
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_3();
    super(['mp3']);
    this.l5m_1 = Minimp3AudioFormat_getInstance();
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_0 extends MP3Decoder {
  constructor() {
    Companion_instance_0 = null;
    super();
    Companion_instance_0 = this;
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_4();
    super(['mp3']);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.m5m_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.n5m_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_5();
    super(['wav']);
  }
}
class Companion_2 extends WAV {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class NativeSoundProvider {
  constructor() {
    this.o5m_1 = 'unknown';
    this.p5m_1 = false;
    this.q5m_1 = Companion_getInstance().w2c_1;
    this.r5m_1 = Companion_getInstance().y2c_1;
    this.s5m_1 = Companion_getInstance().c2d_1;
    this.t5m_1 = Companion_getInstance().w2c_1;
    var tmp = this;
    tmp.u5m_1 = lazy(NativeSoundProvider$audioFormats$delegate$lambda);
  }
  v2n(_set____db54di) {
    this.p5m_1 = _set____db54di;
  }
  z5() {
  }
}
class NativeSoundProviderNew extends NativeSoundProvider {}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_6();
    super();
  }
}
class Companion_3 extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance_3 = null;
    super();
    Companion_instance_3 = this;
  }
}
class HtmlNativeSoundProvider extends NativeSoundProviderNew {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().a5n();
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    this.v5m_1 = Companion_getInstance_1().us('HtmlSimpleSound');
    var tmp = this;
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      var this_0 = tmp_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = this.v5m_1;
        var level = Level_ERROR_getInstance();
        var tmp_3;
        if (this_1.m2q(level)) {
          // Inline function 'korlibs.audio.sound.HtmlSimpleSound.ctx.<anonymous>' call
          this_1.n2q(level, e);
          tmp_3 = Unit_instance;
        }
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.w5m_1 = tmp_0;
    this.x5m_1 = false;
    this.y5m_1 = CompletableDeferred(Job());
    var tmp_4 = this;
    var tmp_5 = this.y5m_1;
    tmp_4.z5m_1 = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp47_safe_receiver = this.w5m_1;
    var _scratchBuffer = tmp47_safe_receiver == null ? null : tmp47_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = HtmlSimpleSound$lambda(unlock, this, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  a5n() {
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.t1();
}
var defaultAudioFormats$delegate;
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
function invalidate($this) {
  $this.g5m_1 = null;
  return $this;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance.d5m([Companion_getInstance_5(), Companion_getInstance_3()]);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_0;
function Companion_getInstance_3() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var DEFAULT_MAX_SAMPLES;
function NativeSoundProvider$audioFormats$delegate$lambda() {
  return get_defaultAudioFormats();
}
var Companion_instance_3;
function Companion_getInstance_6() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  // Inline function 'kotlin.getValue' call
  var this_0 = nativeSoundProvider$delegate;
  nativeSoundProvider$factory();
  return this_0.t1();
}
var nativeSoundProvider$delegate;
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_0().tq()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_6();
  }
  return tmp;
}
function nativeSoundProvider$factory() {
  return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
    return get_nativeSoundProvider();
  }, null);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function HtmlSimpleSound$lambda$lambda($source) {
  return function () {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().x5m_1 = true;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = HtmlSimpleSound_getInstance().v5m_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.audio.sound.HtmlSimpleSound.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'Web Audio was successfully unlocked';
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    HtmlSimpleSound_getInstance().y5m_1.n14(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$lambda($unlock, this$0, $_scratchBuffer) {
  return function (it) {
    var tmp = document;
    var tmp_0;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_0 = $unlock._v;
    }
    tmp.removeEventListener('keydown', tmp_0, true);
    var tmp_1 = document;
    var tmp_2;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_2 = $unlock._v;
    }
    tmp_1.removeEventListener('touchstart', tmp_2, true);
    var tmp_3 = document;
    var tmp_4;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_4 = $unlock._v;
    }
    tmp_3.removeEventListener('touchend', tmp_4, true);
    var tmp_5 = document;
    var tmp_6;
    if ($unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_6 = $unlock._v;
    }
    tmp_5.removeEventListener('mousedown', tmp_6, true);
    var tmp_7;
    if (!(this$0.w5m_1 == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp48_safe_receiver = window.globalAudioContext;
      if (tmp48_safe_receiver == null)
        null;
      else {
        tmp48_safe_receiver.resume();
      }
      var source = this$0.w5m_1.createBufferSource();
      source.buffer = $_scratchBuffer;
      source.connect(this$0.w5m_1.destination);
      source.start(0.0);
      // Inline function 'kotlin.js.asDynamic' call
      if (typeof this$0.w5m_1.resume === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        this$0.w5m_1.resume();
      }
      source.onended = HtmlSimpleSound$lambda$lambda(source);
      tmp_7 = Unit_instance;
    }
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_0, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2, VOID, VOID, [2, 4]);
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable], [1, 3, 4, 2]);
initMetadataForClass(NativeSoundProviderNew, 'NativeSoundProviderNew', NativeSoundProviderNew, VOID, VOID, [1, 3, 4, 2]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider, VOID, VOID, [1, 3, 4, 2]);
initMetadataForCompanion(Companion_3, VOID, VOID, [1, 3, 4, 2]);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider, VOID, VOID, [4, 1, 3, 2]);
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
//endregion
//region block: init
Companion_instance = new Companion();
DEFAULT_MAX_SAMPLES = 39690000;
//endregion
//region block: exports
export {
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
};
//endregion
